<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      defaultLanguage: this._contentData.defaultLanguage
    }
  },
  created() {
    let lang = localStorage.getItem('lang')
    if (!lang || lang === 'undefined') {
      localStorage.setItem('lang', this.defaultLanguage)
    }
    
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
/* @import './assets/css/fonts.css'; */
@import './assets/css/theme.css';
#app {
  font-family: MiSans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* font-weight: 500; */
}
html, body, #app{
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  letter-spacing: 2px;
}
img{
  object-fit: cover;
}
*::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
*{
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.el-header{
  padding: 0;
}
</style>
